var testData = {
    "success":
    {
        "id": 47512,
        "keyword": "car insurance",
        "status": "success",
        "response":
        {
            "questions":
            {
                "query": "car insurance",
                "children":
                [
                    {
                        "query": "Who has the cheapest car insurance?",
                        "children":
                        [
                            {
                                "query": "Who is cheaper than Geico?",
                                "children":
                                [
                                    {
                                        "query": "What car insurance is the cheapest for full coverage?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Who has the cheapest car insurance for seniors?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Why is Geico so cheap?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "What is a fair price for car insurance?",
                                "children":
                                [
                                    {
                                        "query": "How much is insurance monthly?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How much is a car payment per month?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How much is car insurance per year?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Should I pay my car insurance in full or monthly?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "What is the average cost of car maintenance monthly?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How much is insurance for a new car?",
                                        "children":
                                        []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "query": "What are the worst insurance companies?",
                        "children":
                        [
                            {
                                "query": "Who is the number 1 insurance company?",
                                "children":
                                [
                                    {
                                        "query": "Which insurance company is best at paying claims?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Why is progressive so cheap?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Is Progressive better than Geico?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "Who are the top 3 insurance companies?",
                                "children":
                                [
                                    {
                                        "query": "Who is the biggest car insurance company?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Who owns the insurance companies?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Who has the best classic car insurance?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "Do I need insurance the day I buy a car?",
                                "children":
                                [
                                    {
                                        "query": "Can I drive a car home without insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Can I test drive a car without insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "When should you purchase car insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Can I drive a new car home on my old insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Do car dealerships verify insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How does insurance work when buying a used car?",
                                        "children":
                                        []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "query": "Which car insurance is best in India?",
                        "children":
                        [
                            {
                                "query": "Who is best for car insurance?",
                                "children":
                                [
                                    {
                                        "query": "Is HDFC Ergo good for car insurance?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "What are the top 5 car insurance companies?",
                                "children":
                                []
                            },
                            {
                                "query": "Which is the best insurance policy for car?",
                                "children":
                                [
                                    {
                                        "query": "How do I get insurance on my car?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How long do you have to get insurance on a new car?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "What is first party insurance coverage?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Can I get 3 months car insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Can you insurance a car over 15 years old?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How can I check my car insurance policy status?",
                                        "children":
                                        []
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "query": "How do I compare car insurance?",
                        "children":
                        [
                            {
                                "query": "How can I lower my car insurance rates?",
                                "children":
                                [
                                    {
                                        "query": "How do I find the best insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "How can I get a car insurance quote without personal information?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "What are the 10 best insurance companies?",
                                "children":
                                [
                                    {
                                        "query": "Is Mercury Insurance better than Geico?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Why is Allstate so bad?",
                                        "children":
                                        []
                                    }
                                ]
                            },
                            {
                                "query": "What is the best car insurance quote site?",
                                "children":
                                [
                                    {
                                        "query": "How accurate are car insurance quotes?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Does credit score affect car insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Why is my car insurance quote so high?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Is Gabi com legit?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Should I get comprehensive insurance?",
                                        "children":
                                        []
                                    },
                                    {
                                        "query": "Is Ratekick legit?",
                                        "children":
                                        []
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        "location":
        {
            "country_code": "US",
            "id": "585069bfee19ad271e9bc673"
        },
        "public_uid": "0d8a9e41",
        "created_at": "2021-06-22T22:55:26.483Z",
        "updated_at": "2021-06-22T22:56:00.771Z"
    }
}

export default testData